import { LoadingContainer, ModelViewer } from 'peach/components'
import { useParams } from 'peach/router'

import { Page } from 'core/components'
import { useInternalLoanRatesGet } from 'core/types'

const LoanRates = () => {
  const { companyId, personId, loanId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
  }>()

  const { data: rates, isLoading } = useInternalLoanRatesGet({
    companyId,
    personId,
    loanId,
  })

  return (
    <LoadingContainer loading={isLoading}>
      <Page variant='full'>
        <ModelViewer json={rates} />
      </Page>
    </LoadingContainer>
  )
}

export default LoanRates
